import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/opt/build/repo/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/blog/blog.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["PageIntro"] */ "/opt/build/repo/src/app/components/PageIntro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UxCarousel"] */ "/opt/build/repo/src/app/components/UX/UxCarousel.tsx");
